/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { Formik, Field } from 'formik';
import { saveBoothAC } from '../../action-creators';
import { QueuesField, InputField, ControlBoxField } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { setInitialValues } from './utils/form-utils';

const FIELDS = ['controlBoxId', 'queueIds', 'name', 'code', 'uuid', 'secret'];

function BoothForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveBoothAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="name" label="Name" component={InputField} />
          <Field name="code" label="Code" component={InputField} />
          <Field name="uuid" label="UUID" component={InputField} disabled={!!values.id} />
          <Field name="secret" label="Secret" component={InputField} />
          <Field name="controlBoxId" component={ControlBoxField} />
          <Field name="queueIds" component={QueuesField} />
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  queues: state.queues,
  controlBoxes: state.controlBoxes
}))(BoothForm);

export default ConnectedComponent;
